/* eslint-disable no-console */
import { StoragePriority } from "./StoragePriority";

/**
 * Maps storage keys to their respective priorities.
 * Any key not in this list will be treated as NORMAL priority by default.
 */
export const KEY_PRIORITIES: Record<string, StoragePriority> = {
  // CRITICAL
  auth_user: StoragePriority.CRITICAL,
  "auth-storage": StoragePriority.CRITICAL, // Zustand persist key

  // IMPORTANT
  sessionStartTimestamp: StoragePriority.IMPORTANT,
  sessionLoginTime: StoragePriority.IMPORTANT,
  sessionPageViews: StoragePriority.IMPORTANT,

  // NORMAL
  departments_last_update: StoragePriority.NORMAL,
  workspace_selected_channel: StoragePriority.NORMAL,
  "wizard-storage-v2": StoragePriority.NORMAL,

  // LOW
  ikai_sales_chat_history: StoragePriority.LOW,
  ikai_console_logs: StoragePriority.LOW,
  ikai_console_logs_timestamp: StoragePriority.LOW,
  ikai_sales_visitor_id: StoragePriority.LOW,
};

/**
 * Get the priority of a specific storage key.
 * Defaults to NORMAL if the key is not explicitly configured.
 */
export function getPriorityForKey(key: string): StoragePriority {
  return KEY_PRIORITIES[key] ?? StoragePriority.NORMAL;
}

/**
 * Get all configured keys for a specific priority.
 */
export function getKeysByPriority(priority: StoragePriority): string[] {
  return Object.entries(KEY_PRIORITIES)
    .filter(([_, p]) => p === priority)
    .map(([k, _]) => k);
}
